import React, { useState, useEffect, useRef, useMemo } from 'react';
import { ShoppingCart, Plus, Package, Users, LayoutGrid, Trash2, X, Search, Camera, Receipt, Save,
  Minus, Image as ImageIcon, BarChart3, Settings, Printer, Clock, ArrowUpRight, Edit3,
  FileText, Download, AlertTriangle, Ban, UserCheck, Share2, Copy, AlertOctagon, RefreshCw, Truck,
  RotateCcw, ChevronLeft, ChevronRight, ScanBarcode, UserCircle2, Layers, Lock, LogIn, Menu, LogOut,
  HelpCircle, CheckSquare, Square, MapPin, Phone, PauseCircle, PlayCircle, AlertCircle, Banknote,
  CreditCard, Smartphone, BookOpen, Crown, Unlock, Globe, Wallet, History, FileCheck, Boxes, PenLine,
  CreditCard as CardIcon, Store, ArrowRightLeft, UserCog, Briefcase, FileOutput, Megaphone, UserPlus,
  Link, MonitorSmartphone, Contact, FileMinus } from 'lucide-react';
import { apiCall, generateId, formatPrice, formatDate, compressImage,
  base64ToFile, printHtmlDiv, printRawHtml, printBarcodeDiv } from '../utils/utils.js';

const DefectModal = ({ product, suppliers, onClose, onProcessDefect }) => {
    const [qty, setQty] = useState('');
    const [variantName, setVariantName] = useState('');
    const supplierName = product.supplier ? (suppliers.find(s => s.id === product.supplier)?.name || 'Unknown Supplier') : 'No Supplier Linked';

    return (
        <div className="fixed inset-0 bg-[#1a1a1a]/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-sm rounded-xl shadow-lg border border-[#e1e3e5] overflow-hidden flex flex-col">
                <div className="p-4 border-b border-[#e1e3e5] flex justify-between items-center bg-[#fbeae5]">
                    <h3 className="font-bold text-[#d82c0d] flex items-center gap-2"><AlertTriangle size={18}/> Log Defective Item</h3>
                    <button onClick={onClose} className="text-[#5c5f62]"><X size={20}/></button>
                </div>
                <form onSubmit={(e) => { e.preventDefault(); onProcessDefect(product, variantName, parseInt(qty)); }} className="p-4 flex-1">
                    <div className="mb-4">
                        <p className="font-bold text-[#1a1a1a] text-sm">{product.name}</p>
                        <p className="text-xs text-[#5c5f62] mt-1">Supplier: {supplierName}</p>
                    </div>
                    {product.hasVariants && (
                        <div className="mb-4">
                            <label className="text-xs font-semibold text-[#5c5f62] uppercase block mb-1">Variant</label>
                            <select required value={variantName} onChange={e=>setVariantName(e.target.value)} className="w-full p-2 border border-[#c9cccf] rounded-lg text-sm bg-white outline-none">
                                <option value="">Select Option...</option>
                                {product.variants.map((v, i) => <option key={i} value={v.name}>{v.name} (Stock: {v.stock})</option>)}
                            </select>
                        </div>
                    )}
                    <div className="mb-4">
                        <label className="text-xs font-semibold text-[#5c5f62] uppercase block mb-1">Damaged Quantity</label>
                        <input required type="number" min="1" max={product.stock} value={qty} onChange={e=>setQty(e.target.value)} className="w-full p-2 border border-[#c9cccf] rounded-lg text-sm outline-none" placeholder="Enter quantity" />
                    </div>
                    <div className="bg-[#f6f7f8] p-3 rounded-lg border border-[#e1e3e5] flex justify-between items-center mb-4">
                        <span className="font-bold text-sm text-[#1a1a1a]">Financial Loss</span>
                        <span className="text-sm font-black text-[#d82c0d]">{formatPrice((parseFloat(product.cost_price) || 0) * (parseInt(qty) || 0))}</span>
                    </div>
                    <button type="submit" disabled={!qty || (product.hasVariants && !variantName)} className="w-full bg-[#d82c0d] text-white py-2.5 rounded-lg font-semibold shadow-sm hover:bg-[#bf260a] transition-colors disabled:opacity-50">Confirm Defect & Deduct Stock</button>
                </form>
            </div>
        </div>
    );
};

export default DefectModal;
